<template>
    <QitButton
        data-qs="language-selector"
        padding="sm"
        size="13px"
        class="grey-hover"
        :no-caps="false"
        :text-color="isXSmall ? 'on-navbar-color' : 'on-icon-color'"
        :color="isXSmall ? 'default' : 'transparent'"
        :icon="isXSmall ? mobileIcon : icon"
        :label="currentLanguage"
        @click="toggleDrawer"
    >
        <q-tooltip>{{ $t("shared.Language") }}</q-tooltip>
    </QitButton>
    <q-dialog v-model="show" v-if="isXSmall" maximized transition-show="scale" transition-hide="scale">
        <div class="bg-grey-1">
            <div class="row justify-end q-mt-sm">
                <div>
                    <q-btn
                        round
                        icon="fa fa-solid fa-xmark icon-color"
                        @click="() => (show = false)"
                        data-qs="dialog-close-btn"
                    />
                </div>
            </div>
            <LanguageSelector />
        </div>
    </q-dialog>
    <TitleContentDrawer
        v-else
        test-id-prefix="language-selector"
        :visible="show"
        :title="$t('shared.Select language')"
        @on-close="closeDrawer"
    >
        <div class="q-mx-md column col-grow no-wrap">
            <LanguageSelector />
        </div>
    </TitleContentDrawer>
</template>

<script setup lang="ts">
import TitleContentDrawer from "@/shared/components/side-panel/drawer/title-content-drawer.vue";
import { useScreenSize } from "@/shared/screen/composables/screen-size.ts";
import { computed, ref } from "vue";
import { getUiLanguage } from "@/shared/services/providers/language-provider.ts";
import LanguageSelector from "./language-selector.vue";
import QitButton from "@/shared/components/buttons/qit-button.vue";

defineProps<{
    icon: string;
    mobileIcon: string;
}>();

const show = ref(false);
const currentLanguage = computed(() => getUiLanguage());
const { isXSmall } = useScreenSize();

const toggleDrawer = () => {
    show.value = !show.value;
};

const closeDrawer = () => {
    show.value = false;
};
</script>
